var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNetwork(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    id: "BigData",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "#000000",
    className: "color000000 svgShape"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-8.41 -12.269)",
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(56 86.768)",
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 193,
    height: 69,
    fill: "#797979",
    transform: "translate(-.09 -.499)",
    className: "color01a7f1 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#797979",
    d: "M.106.106V68.485H193V.106H.106M0,0H193.109V68.59H0Z",
    className: "color01a7f1 svgShape"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "#ffffff",
    transform: "translate(146.91 24.501)",
    className: "colorffffff svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M.106.106V21H21V.106H.106M0,0H21.1V21.1H0Z",
    transform: "translate(146.678 24.27)",
    className: "colorffffff svgShape"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 11,
    cy: 10.5,
    fill: "#ffffff",
    rx: 11,
    ry: 10.5,
    transform: "translate(24.91 24.501)",
    className: "colorffffff svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M10.552.106A10.447,10.447,0,1,0,21,10.552,10.459,10.459,0,0,0,10.552.106m0-.106A10.552,10.552,0,1,1,0,10.552,10.552,10.552,0,0,1,10.552,0Z",
    transform: "translate(25.326 24.27)",
    className: "colorffffff svgShape"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10.5,
    r: 10.5,
    fill: "#ffffff",
    transform: "translate(56.91 24.501)",
    className: "colorffffff svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M10.552.106A10.447,10.447,0,1,0,21,10.552,10.459,10.459,0,0,0,10.552.106m0-.106A10.552,10.552,0,1,1,0,10.552,10.552,10.552,0,0,1,10.552,0Z",
    transform: "translate(56.983 24.27)",
    className: "colorffffff svgShape"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10.5,
    r: 10.5,
    fill: "#ffffff",
    transform: "translate(88.909 24.501)",
    className: "colorffffff svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M10.552.106A10.447,10.447,0,1,0,21,10.552,10.459,10.459,0,0,0,10.552.106m0-.106A10.552,10.552,0,1,1,0,10.552,10.552,10.552,0,0,1,10.552,0Z",
    transform: "translate(88.64 24.27)",
    className: "colorffffff svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(56 403.339)",
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 193,
    height: 69,
    fill: "#797979",
    transform: "translate(-.09 -.07)",
    className: "color01a7f1 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#797979",
    d: "M.106.106V68.485H193V.106H.106M0,0H193.109V68.59H0Z",
    className: "color01a7f1 svgShape"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "#ffffff",
    transform: "translate(146.91 23.93)",
    className: "colorffffff svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M.106.106V21H21V.106H.106M0,0H21.1V21.1H0Z",
    transform: "translate(146.678 24.27)",
    className: "colorffffff svgShape"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 11,
    cy: 10.5,
    fill: "#ffffff",
    rx: 11,
    ry: 10.5,
    transform: "translate(24.91 23.93)",
    className: "colorffffff svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M10.552.106A10.447,10.447,0,1,0,21,10.552,10.459,10.459,0,0,0,10.552.106m0-.106A10.552,10.552,0,1,1,0,10.552,10.552,10.552,0,0,1,10.552,0Z",
    transform: "translate(25.326 24.27)",
    className: "colorffffff svgShape"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10.5,
    r: 10.5,
    fill: "#ffffff",
    transform: "translate(56.91 23.93)",
    className: "colorffffff svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M10.552.106A10.447,10.447,0,1,0,21,10.552,10.459,10.459,0,0,0,10.552.106m0-.106A10.552,10.552,0,1,1,0,10.552,10.552,10.552,0,0,1,10.552,0Z",
    transform: "translate(56.983 24.27)",
    className: "colorffffff svgShape"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10.5,
    r: 10.5,
    fill: "#ffffff",
    transform: "translate(88.909 23.93)",
    className: "colorffffff svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M10.552.106A10.447,10.447,0,1,0,21,10.552,10.459,10.459,0,0,0,10.552.106m0-.106A10.552,10.552,0,1,1,0,10.552,10.552,10.552,0,0,1,10.552,0Z",
    transform: "translate(88.64 24.27)",
    className: "colorffffff svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#707070",
    d: "M970.511,4047.835H891.552a10.552,10.552,0,1,1,0-21.1h68.406V3925.946a10.553,10.553,0,0,1,10.552-10.553H1026a10.552,10.552,0,1,1,0,21.1H981.063v100.784A10.552,10.552,0,0,1,970.511,4047.835Z",
    opacity: 0.3,
    transform: "translate(-642.444 -3828.21)",
    className: "color707070 svgShape"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(56 165.91)",
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 193,
    height: 68,
    fill: "#797979",
    transform: "translate(-.09 .358)",
    className: "color01a7f1 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#797979",
    d: "M.106.106V68.485H193V.106H.106M0,0H193.109V68.59H0Z",
    className: "color01a7f1 svgShape"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "#ffffff",
    transform: "translate(146.91 24.358)",
    className: "colorffffff svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M.106.106V21H21V.106H.106M0,0H21.1V21.1H0Z",
    transform: "translate(146.678 24.27)",
    className: "colorffffff svgShape"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 11,
    cy: 10.5,
    fill: "#ffffff",
    rx: 11,
    ry: 10.5,
    transform: "translate(24.91 24.358)",
    className: "colorffffff svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M10.552.106A10.447,10.447,0,1,0,21,10.552,10.459,10.459,0,0,0,10.552.106m0-.106A10.552,10.552,0,1,1,0,10.552,10.552,10.552,0,0,1,10.552,0Z",
    transform: "translate(25.326 24.27)",
    className: "colorffffff svgShape"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10.5,
    r: 10.5,
    fill: "#ffffff",
    transform: "translate(56.91 24.358)",
    className: "colorffffff svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M10.552.106A10.447,10.447,0,1,0,21,10.552,10.459,10.459,0,0,0,10.552.106m0-.106A10.552,10.552,0,1,1,0,10.552,10.552,10.552,0,0,1,10.552,0Z",
    transform: "translate(56.983 24.27)",
    className: "colorffffff svgShape"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10.5,
    r: 10.5,
    fill: "#ffffff",
    transform: "translate(88.909 24.358)",
    className: "colorffffff svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M10.552.106A10.447,10.447,0,1,0,21,10.552,10.459,10.459,0,0,0,10.552.106m0-.106A10.552,10.552,0,1,1,0,10.552,10.552,10.552,0,0,1,10.552,0Z",
    transform: "translate(88.64 24.27)",
    className: "colorffffff svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#707070",
    d: "M1024.549,4108.6h-133a10.553,10.553,0,0,1,0-21.105h133a10.553,10.553,0,0,1,0,21.105Z",
    opacity: 0.3,
    transform: "translate(-642.444 -3818.704)",
    className: "color707070 svgShape"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(56 245.053)",
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 193,
    height: 68,
    fill: "#797979",
    transform: "translate(-.09 .215)",
    className: "color01a7f1 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#797979",
    d: "M.106.106V68.485H193V.106H.106M0,0H193.109V68.59H0Z",
    className: "color01a7f1 svgShape"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "#ffffff",
    transform: "translate(146.91 24.215)",
    className: "colorffffff svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M.106.106V21H21V.106H.106M0,0H21.1V21.1H0Z",
    transform: "translate(146.678 24.27)",
    className: "colorffffff svgShape"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 11,
    cy: 10.5,
    fill: "#ffffff",
    rx: 11,
    ry: 10.5,
    transform: "translate(24.91 24.215)",
    className: "colorffffff svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M10.552.106A10.447,10.447,0,1,0,21,10.552,10.459,10.459,0,0,0,10.552.106m0-.106A10.552,10.552,0,1,1,0,10.552,10.552,10.552,0,0,1,10.552,0Z",
    transform: "translate(25.326 24.27)",
    className: "colorffffff svgShape"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10.5,
    r: 10.5,
    fill: "#ffffff",
    transform: "translate(56.91 24.215)",
    className: "colorffffff svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M10.552.106A10.447,10.447,0,1,0,21,10.552,10.459,10.459,0,0,0,10.552.106m0-.106A10.552,10.552,0,1,1,0,10.552,10.552,10.552,0,0,1,10.552,0Z",
    transform: "translate(56.983 24.27)",
    className: "colorffffff svgShape"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10.5,
    r: 10.5,
    fill: "#ffffff",
    transform: "translate(88.909 24.215)",
    className: "colorffffff svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M10.552.106A10.447,10.447,0,1,0,21,10.552,10.459,10.459,0,0,0,10.552.106m0-.106A10.552,10.552,0,1,1,0,10.552,10.552,10.552,0,0,1,10.552,0Z",
    transform: "translate(88.64 24.27)",
    className: "colorffffff svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#707070",
    d: "M1026.277,4259.629h-54.26a10.552,10.552,0,0,1-10.552-10.552V4183.6H891.552a10.552,10.552,0,0,1,0-21.1h80.464a10.552,10.552,0,0,1,10.552,10.552v65.472h43.708a10.552,10.552,0,0,1,0,21.1Z",
    opacity: 0.3,
    transform: "translate(-642.444 -3814.561)",
    className: "color707070 svgShape"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(56 324.196)",
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 193,
    height: 69,
    fill: "#797979",
    transform: "translate(-.09 .072)",
    className: "color01a7f1 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#797979",
    d: "M.106.106V68.485H193V.106H.106M0,0H193.109V68.59H0Z",
    className: "color01a7f1 svgShape"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "#ffffff",
    transform: "translate(146.91 24.072)",
    className: "colorffffff svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M.106.106V21H21V.106H.106M0,0H21.1V21.1H0Z",
    transform: "translate(146.678 24.27)",
    className: "colorffffff svgShape"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 11,
    cy: 10.5,
    fill: "#ffffff",
    rx: 11,
    ry: 10.5,
    transform: "translate(24.91 24.072)",
    className: "colorffffff svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M10.552.106A10.447,10.447,0,1,0,21,10.552,10.459,10.459,0,0,0,10.552.106m0-.106A10.552,10.552,0,1,1,0,10.552,10.552,10.552,0,0,1,10.552,0Z",
    transform: "translate(25.326 24.27)",
    className: "colorffffff svgShape"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10.5,
    r: 10.5,
    fill: "#ffffff",
    transform: "translate(56.91 24.072)",
    className: "colorffffff svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M10.552.106A10.447,10.447,0,1,0,21,10.552,10.459,10.459,0,0,0,10.552.106m0-.106A10.552,10.552,0,1,1,0,10.552,10.552,10.552,0,0,1,10.552,0Z",
    transform: "translate(56.983 24.27)",
    className: "colorffffff svgShape"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10.5,
    r: 10.5,
    fill: "#ffffff",
    transform: "translate(88.909 24.072)",
    className: "colorffffff svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M10.552.106A10.447,10.447,0,1,0,21,10.552,10.459,10.459,0,0,0,10.552.106m0-.106A10.552,10.552,0,1,1,0,10.552,10.552,10.552,0,0,1,10.552,0Z",
    transform: "translate(88.64 24.27)",
    className: "colorffffff svgShape"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 89,
    height: 90,
    fill: "#666666",
    rx: 12,
    transform: "translate(383.909 53.269)",
    className: "color0285cb svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "M12.663.106A12.557,12.557,0,0,0,.106,12.663V78.088A12.557,12.557,0,0,0,12.663,90.645H75.977A12.557,12.557,0,0,0,88.534,78.088V12.663A12.557,12.557,0,0,0,75.977.106H12.663m0-.106H75.977A12.663,12.663,0,0,1,88.64,12.663V78.088A12.663,12.663,0,0,1,75.977,90.75H12.663A12.663,12.663,0,0,1,0,78.088V12.663A12.663,12.663,0,0,1,12.663,0Z",
    transform: "translate(384.179 53)",
    className: "color0285cb svgShape"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 89,
    height: 90,
    fill: "#666666",
    rx: 12,
    transform: "translate(383.909 222.269)",
    className: "color0285cb svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "M12.663.106A12.557,12.557,0,0,0,.106,12.663V78.088A12.557,12.557,0,0,0,12.663,90.645H75.977A12.557,12.557,0,0,0,88.534,78.088V12.663A12.557,12.557,0,0,0,75.977.106H12.663m0-.106H75.977A12.663,12.663,0,0,1,88.64,12.663V78.088A12.663,12.663,0,0,1,75.977,90.75H12.663A12.663,12.663,0,0,1,0,78.088V12.663A12.663,12.663,0,0,1,12.663,0Z",
    transform: "translate(384.179 221.838)",
    className: "color0285cb svgShape"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 89,
    height: 90,
    fill: "#666666",
    rx: 12,
    transform: "translate(383.909 393.269)",
    className: "color0285cb svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "M12.663.106A12.557,12.557,0,0,0,.106,12.663V78.088A12.557,12.557,0,0,0,12.663,90.645H75.977A12.557,12.557,0,0,0,88.534,78.088V12.663A12.557,12.557,0,0,0,75.977.106H12.663m0-.106H75.977A12.663,12.663,0,0,1,88.64,12.663V78.088A12.663,12.663,0,0,1,75.977,90.75H12.663A12.663,12.663,0,0,1,0,78.088V12.663A12.663,12.663,0,0,1,12.663,0Z",
    transform: "translate(384.179 392.787)",
    className: "color0285cb svgShape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetwork);
export default __webpack_public_path__ + "static/media/network.b68b2f1ff416f6ba25c3e9829ece0e86.svg";
export { ForwardRef as ReactComponent };